import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { useDispatch, useSelector } from 'react-redux';
import { bootstrapUser } from './store/slices/authSlice';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './pages/Dashboard';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import CreateProduct from './pages/CreateProduct';
import EditProduct from './pages/EditProduct';
import AccountInfo from './pages/AccountInfo';
import Documents from './pages/Documents';
import RFQsOrders from './pages/RFQsOrders';
import Analytics from './pages/Analytics';
import Browse from './pages/Browse';
import SavedProducts from './pages/SavedProducts';
import AdminProductModeration from './pages/admin/AdminProductModeration';
import AdminMessages from './pages/admin/AdminMessages';
import AdminOrders from './pages/admin/AdminOrders';
import NotFound from './pages/NotFound';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
import EditOrder from './pages/EditOrder';
import AdminUsers from './pages/admin/AdminUsers';
import AuditLogs from './pages/admin/AuditLogs';
import AdminRoute from './components/common/AdminRoute';
import WHSRoute from './components/common/WHSRoute';
import RTLRoute from './components/common/RTLRoute';
import RetailerInbox from './pages/RetailerInbox';
import ToastContainer from './components/common/ToastContainer';
import './App.css';

const AppInner = () => {
  const dispatch = useDispatch();
  const { token, bootstrapped } = useSelector(s => s.auth);

  useEffect(() => {
    if (token && !bootstrapped) {
      dispatch(bootstrapUser());
    }
  }, [token, bootstrapped, dispatch]);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Layout />}> 
            <Route index element={<Dashboard />} />
            <Route path="account" element={<AccountInfo />} />
            
            <Route path="documents" element={<Documents />} />
            <Route path="rfqs" element={<RFQsOrders />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/:id" element={<OrderDetails />} />
            <Route path="orders/:id/edit" element={<EditOrder />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="browse" element={<Browse />} />
            <Route path="saved" element={<SavedProducts />} />
            <Route path="products" element={<ProductList />} />
            <Route path="products/:id" element={<ProductDetail />} />
            <Route path="products/:id/edit" element={<EditProduct />} />
            <Route path="products/create" element={<CreateProduct />} />
            {/* Admin */}
            <Route path="support" element={<WHSRoute><AdminMessages /></WHSRoute>} />
            <Route path="messages" element={<RTLRoute><RetailerInbox /></RTLRoute>} />
            <Route path="admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
            <Route path="admin/audit" element={<AdminRoute><AuditLogs /></AdminRoute>} />
            <Route path="admin/products" element={<AdminRoute><AdminProductModeration /></AdminRoute>} />
            <Route path="admin/messages" element={<AdminRoute><AdminMessages /></AdminRoute>} />
            <Route path="admin/orders" element={<AdminRoute><AdminOrders /></AdminRoute>} />
            {/* Catch-all inside layout */}
            <Route path="*" element={<NotFound />} />
          </Route>
          {/* Fallback for routes outside layout */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer />
      </div>
    </Router>
  );
};

function App() {
  return (
    <Provider store={store}>
      <AppInner />
    </Provider>
  );
}

export default App;
